import { toNumber } from 'lodash'
import { head } from 'ramda'
import { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button, Box, FieldMessage } from '@machobear/design-system'
import { breakpoints } from '@machobear/design-system/css'
import useMediaQuery from '@/hooks/use-media-query'

const MAX_SIZE_MB = 10
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1048576

const UploadButton = ({ listingId, handleSuccessEvent }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [rejectError, setRejectError] = useState('')
  const [isRejected, setIsRejected] = useState(false)
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.tablet}px)`)

  const handleOnClick = () => {
    setIsRejected(false)
    open()
  }

  const onUploadAccepted = async files => {
    dispatch.listing.uploadVerifyDocument({
      listingId: toNumber(listingId),
      file: head(files)
    })
    handleSuccessEvent()
  }

  const sizeError = t('b.profile.edit.max_upload_size.error', 'Max file upload size is 10MB')
  const typeError = t(
    'b.profile.edit.wrong_file_type.error',
    'Sorry, we do not support this file type'
  )

  const { getInputProps, open } = useDropzone({
    accept: {
      'image/png': ['.png'],
      'image/jpg': ['.jpg', '.jpeg'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'application/pdf': ['.pdf']
    },
    multiple: false,
    noKeyboard: true,
    maxSize: MAX_SIZE_BYTES,
    onDrop: (_, d) => {
      if (d.length > 0) {
        d[0]?.file?.size > MAX_SIZE_BYTES ? setRejectError(sizeError) : setRejectError(typeError)
        setIsRejected(true)
      }
    },
    onDropAccepted: onUploadAccepted
  })
  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      style={{ width: isMobile ? '100%' : 160, height: 40 }}
      gap="xxsmall"
    >
      <input {...getInputProps()} />
      <Button variant="solid" size="standard" onClick={handleOnClick}>
        {t('l.verify_listing.view.upload.button', 'Upload')}
      </Button>
      {isRejected && <FieldMessage id="upload-error" tone="critical" message={rejectError} />}
    </Box>
  )
}

export default UploadButton
